// Строка «агент работает» — та же, что мигает в консоли под последним блоком:
//
//   ✻ Работаю… (12s · esc — прервать)
//
// Без неё окно во время работы выглядит замершим: в панели нет курсора
// терминала, и единственным признаком жизни остаётся точка в шапке.

import { useEffect, useState } from 'react'

/** Кадры «звёздочки» — те же, что перебирает claude code. */
const FRAMES = ['✢', '✳', '✶', '✻', '✽']

export default function BusyLine({ onInterrupt }: { onInterrupt(): void }) {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const id = window.setInterval(() => setTick((n) => n + 1), 200)
    return () => window.clearInterval(id)
  }, [])

  // Один таймер на всё: кадр меняется каждые 200 мс, секунды — каждые пять кадров.
  const seconds = Math.floor(tick / 5)

  return (
    <div className="t-busy">
      <span className="t-busy__glyph">{FRAMES[tick % FRAMES.length]}</span>
      <span>
        Работаю… (
        {seconds}s ·{' '}
        <button type="button" className="t-more t-busy__esc" onClick={onInterrupt}>
          esc — прервать
        </button>
        )
      </span>
    </div>
  )
}
